import { MainV3ApiBase } from './base';
import { CourseId, CourseIndexView, CourseShowView } from '../types/courses';

export const CourseApis = {
  base() {
    return MainV3ApiBase.appendPath('courses');
  },
  index(preview = false): Promise<CourseIndexView[]> {
    return this.base().get({ preview });
  },
  show(id: CourseId, preview = false): Promise<CourseShowView> {
    return this.base().withId(id).get({ preview });
  },
  forMember() {
    return this.base().appendPath('for_member').get();
  },
};
